import { createRequestTypes } from '../utils';

export const GENERALDASHBOARD_LIST = createRequestTypes('generalDashboards/GENERALDASHBOARD_LIST');
export const FETCH_GENERALDASHBOARDS = createRequestTypes('generalDashboards/FETCH_GENERALDASHBOARDS');
export const SAVE_GENERALDASHBOARD = createRequestTypes('generalDashboard/SAVE_GENERALDASHBOARD');
export const DELETE_GENERALDASHBOARD = createRequestTypes('generalDashboard/DELETE_GENERALDASHBOARD');
export const UPDATE_GENERALDASHBOARD = 'generalDashboard/UPDATE_GENERALDASHBOARD';
